import _ from 'lodash';
import './systemSettings.less';
import * as utility from '../misc/utility';
import { addCalendarDays } from '../misc/DateCalculator';

let NEXT_NEW_PERIOD_KEY = 1;

class PaymentSettingsPeriod {
    constructor(key, start) {
        this.key = key;
        this.StartDate = start;
        this.EndDate = null;
    }

    static fromResponse(src) {
        let result = new PaymentSettingsPeriod(src.Id, utility.parseDate(src.StartDate));
        result.Id = src.Id;
        result.MaxMeetingAmount = src.MaxMeetingAmount;
        result.MaxLostIncomeAmount = src.MaxLostIncomeAmount;
        result.LostIncomeGuardLimit = src.LostIncomeGuardLimit;
        return result;
    }

    toJSON() {
        return {
            Id: this.Id,
            StartDate: this.StartDate,
            MaxMeetingAmount: this.MaxMeetingAmount,
            MaxLostIncomeAmount: this.MaxLostIncomeAmount,
            LostIncomeGuardLimit: this.LostIncomeGuardLimit,
        };
    }
}

class PaymentSettingsPeriodCollection {
    constructor(srcs) {
        this.list = _.map(srcs, x => PaymentSettingsPeriod.fromResponse(x));
        this.hasChanged = false;
        this.sort();
    }
    
    _createPeriod(template) {
        let startDate = template ? new Date(template.StartDate.getFullYear() + 1, template.StartDate.getMonth(), template.StartDate.getDate()) : utility.todayDate();
        let period = new PaymentSettingsPeriod('NEW:' + (NEXT_NEW_PERIOD_KEY++), startDate);
        if (template) {
            period.MaxMeetingAmount = template.MaxMeetingAmount;
            period.MaxLostIncomeAmount = template.MaxLostIncomeAmount;
            period.LostIncomeGuardLimit = template.LostIncomeGuardLimit;
        }
        return period;
    }

    fromDate(date) {
        let time = date.getTime();
        return _.find(this.list, x => x.StartDate.getTime() === time);
    }

    latest() {
        return _.first(this.list);
    }

    toJSON() {
        return _.map(this.list, x => x.toJSON());
    }

    add(template) {
        let period = this._createPeriod(template);
        this.list = [period, ...this.list];
        this.sort();
        this.hasChanged = true;
        return period;
    }

    remove(period) {
        if (period) {
            let pos = this.list.indexOf(period);
            if (pos >= 0) {
                this.list = this.list.slice();
                this.list.splice(pos, 1);
                this.hasChanged = true;
                this._updateEndDate();
                return pos;
            }
        }
        return -1;
    }

    _updateEndDate() {
        let nextStart = null;
        _.each(this.list, x => {
            x.EndDate = addCalendarDays(nextStart, -1);
            nextStart = x.StartDate;
        });
    }

    sort() {
        this.list = _.orderBy(this.list, ['StartDate'], ['desc']);
        this._updateEndDate();
    }
}

angular.module("tromanWeb").controller('SystemSettingsController', ['tromanServer', 'stateService', 'dialogService', 'systemInfo', function (tromanServer, stateService, dialogService, systemInfo) {

    var isSaving = false;

    this.exportError = null;
    this.exportSuccess = false;
    this.applyMunicipalityResult = null;
    /** @type {PaymentSettingsPeriod} */
    this.selectedPeriod = null;
    /** @type {PaymentSettingsPeriodCollection} */
    this.periods = null;
    /** @type {Date} */
    this.selectedStartDate = null;
    this.invalidExistingPeriod = false;

    this.canExport = function () {
        return this.form && !this.form.$dirty && !isSaving;
    };

    this.selectedPeriodChanged = function() {
        this.selectedStartDate = this.selectedPeriod?.StartDate;
        this.invalidExistingPeriod = false;
    };

    this.addPeriod = function() {
        this.selectedPeriod = this.periods.add(this.selectedPeriod);
        this.selectedPeriodChanged();
    };

    this.removePeriod = function() {
        let pos = this.periods.remove(this.selectedPeriod);
        this.selectedPeriod = this.periods.list[pos < 1 ? 0 : pos - 1];
        this.selectedPeriodChanged();
    };

    this.selectedStartDateChanged = function() {
        if (this.selectedPeriod && this.selectedStartDate) {
            let existing = this.periods.fromDate(this.selectedStartDate);
            if (existing && existing !== this.selectedPeriod) {
                this.invalidExistingPeriod = true;
            } else {
                this.invalidExistingPeriod = false;
                this.selectedPeriod.StartDate = this.selectedStartDate;
                this.periods.sort();
            }
        }
    };

    this.export = function () {
        if (!this.canExport()) return;

        isSaving = true;

        this.exportError = null;
        this.exportSuccess = false;
        tromanServer.System.updatePublik()
            .then(() => {
                isSaving = false;
                this.exportSuccess = true;
            })
            .catch(err => {
                isSaving = false;
                this.exportError = err;
            });
    };


    this.canApplyMunicipalityCodeList = function () {
        if (this.form == null || this.form.$dirty) return false;
        if (isSaving) return false;
        if (this.settings == null || this.settings.DefaultValidMunicipalities == null || this.settings.DefaultValidMunicipalities.length === 0) return false;
        return true;
    };

    this.applyMunicipalityCodeList = function applyMunicipalityCodeList() {
        if (!this.canApplyMunicipalityCodeList()) return;

        if (systemInfo.IsSparNotificationsEnabled) {
            dialogService.confirm([
                'Tillämpa grundinställningarna för kommun-/länskod på alla aktiva organisationer.',
                'Nuvarande inställningar på alla aktiva organisationer kommer helt ersättas av grundinställningarna.',
                'Samtidigt kommer kontroll av kommunkod aktiveras på alla aktiva uppdrag i organisationerna.',
            ]).then(() => {
                isSaving = true;

                tromanServer.System.applyMunicipalityCodeSettings()
                    .then(() => {
                        isSaving = false;
                        this.applyMunicipalityResult = true;
                    })
                    .catch(err => {
                        isSaving = false;
                        this.applyMunicipalityResult = err;
                    });
            });
        } else {
            dialogService.notify([
                "Denna funktion kräver att tjänsten för att hämta folkbokförda uppgifter från Statens Personadressregister (SPAR) är aktiverad.",
                "Vill ni aktivera denna tjänst kontakta Troman på support@troman.se."],
                "Tjänsten inte aktiv");
        }
    };

    this.canSave = function () {
        return this.form && (this.form.$dirty || this.periods?.hasChanged) && this.form.$valid && !this.invalidExistingPeriod && !isSaving;
    };

    this.save = function save() {

        if (!this.canSave()) return;

        this.form.$commitViewValue();
        this.form.$setSubmitted();

        if (this.form.$invalid) return;

        this.settings.PaymentSettingsPeriods = this.periods?.toJSON();

        isSaving = true;
        tromanServer.System.setSettings(this.settings)
            .finally(() => { isSaving = false; })
            .then(() => { 
                stateService.reload();
            })
            .catch(dialogService.error);
    };

    this.loadItems = function() {
        tromanServer.System.getSettings().then(data => {
            this.settings = data;
            this.periods = new PaymentSettingsPeriodCollection(data.PaymentSettingsPeriods);
            this.selectedPeriod = this.periods.latest();
            this.selectedStartDate = this.selectedPeriod?.StartDate;
            this.invalidExistingPeriod = false;
        }).catch((err) => {
            this.settings = null;
            dialogService.error(err);
        });
    };

    this.loadItems();
}]);
